export const MENUS_SET_MODULOS = "MENUS_SET_MODULOS";
